import React from "react"

const CONFIDENCE_CLASS = {
    HIGH: "idm-chip-high",
    MEDIUM: "idm-chip-medium",
    LOW: "idm-chip-low",
}

function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text)
}

const CopyButton = ({ text, label }) => (
    <button type="button" className="idm-copy-chip" title={label || "Copy"} aria-label={label || "Copy"} onClick={() => copy(text)}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="9" y="9" width="12" height="12" rx="2" />
            <path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" />
        </svg>
    </button>
)

const ExtractedFieldRow = ({ row }) => {
    const confidence = (row.confidence || "").toUpperCase()
    return (
        <div className="idm-field-row">
            <span className="idm-field-label">{row.label}</span>
            <span className="idm-field-value">{row.value}</span>
            {!!confidence && <span className={`idm-chip ${CONFIDENCE_CLASS[confidence] || "idm-chip-low"}`}>{confidence}</span>}
            <CopyButton text={row.value} label={`Copy ${row.label}`} />
        </div>
    )
}

export { CopyButton }
export default ExtractedFieldRow
